import moment from 'moment'
const dateFormat = 'YYYY-MM-DD'
const timeFormat = 'HH:mm:ss'

export function makeOnlineExamData (data) {
  let returnData = {
    session_id: data.session_id,
    class_id: data.class_id,
    schedule_type: data.schedule_type,
    section_id: data.section_id ? data.section_id : null,
    instruction_id: data.instruction_id,
    name: data.name,
    description: data.description,
    date: moment(data.date, dateFormat),
    expire_date: moment(data.expire_date, dateFormat),
    start_time: moment(data.start_time, timeFormat),
    end_time: moment(data.end_time, timeFormat),
    duration: data.duration,
    type: data.type,
    pass_mark: data.pass_mark,
    full_mark: data.full_mark,
    questionwise_mark: data.questionwise_mark,
    negative_mark: data.negative_mark,
    shuffle: data.shuffle,
    after_exam: data.after_exam,
    category_result: data.category_result,
    status: data.status,
    publish_date: moment(data.publish_on),
    publish_time: moment(data.publish_on),
    // declare_date: undefined,
    // declare_time: undefined,
    declare_date: data.declare_on === null ? undefined : moment(data.declare_on),
    declare_time: data.declare_on === null ? undefined : moment(data.declare_on),
  }

  return returnData
}
export function makeClassSectionExamSubjectData (subjectData) {
  const subjects = subjectData.map((element, index) => ({
    ['subjects[' + element.subject_id + '][selected]']: true,
    ['subjects[' + element.subject_id + '][subject_id]']: element.subject_id,
    ['subjects[' + element.subject_id + '][cut_off_mark]']: element.cutoff_mark,
    ['subjects[' + element.subject_id + '][serialNo]']: element.serialNo,
    cut_off_stat: element.cutoff_mark !== null,
  }))

  let returnData = {}

  subjects.forEach(element => {
    returnData = { ...returnData, ...element }
  })

  return returnData
}
